import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {
  SharedListToggleService
} from '../../services/shared-list-toggle/shared-list-toggle.service';
import {
  SharedListStateService
} from '../../services/shared-list-state-service/shared-list-state.service';
import { ClearAllSelectedSharedListVehicles, ClearAllSelectedVehiclesUuid, SharedListToggleState, VehicleToggleState } from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';


@Component({
    selector: 'app-shared-list-action-bar',
    templateUrl: './shared-list-action-bar.component.html',
    styleUrls: ['./shared-list-action-bar.component.scss'],
    imports: [TranslocoDirective]
})
export class SharedListActionBarComponent implements OnDestroy, OnInit {
  itemCount = 0;
  private readonly destroyed$ = new Subject();
  @Output() onActionSelected = new EventEmitter<string>();
  generalErrorMessage: string;
  @Input() declineEnabled = true;
  @Input() isCommonMultiCheckboxImplementationEnabled: boolean;

  constructor(
    private readonly store: Store,
    private readonly sharedListToggleService: SharedListToggleService,
    private readonly sharedListStateService: SharedListStateService
  ) {}

  ngOnInit(): void {
    this.updateItemCount();
  }

  acceptAllSelected() {
    this.onActionSelected.emit('ACCEPT');
    this.generalErrorMessage = null;
  }

  declineAllSelected() {
    this.onActionSelected.emit('DECLINE');
    this.generalErrorMessage = null;
  }

  cancel() {
    this.store.dispatch(new ClearAllSelectedVehiclesUuid());
    this.clearSharedListState();
  }

  clearSharedListState() {
    this.sharedListToggleService.reset();
    this.store.dispatch(new ClearAllSelectedSharedListVehicles());
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get showSharedListActionBar() {
    return this.sharedListStateService.hasDealerAndListNameSpecified && this.itemCount > 0;
  }

  updateItemCount() {
    if (this.isCommonMultiCheckboxImplementationEnabled) {
      this.store
        .select(VehicleToggleState.selectedVehicles)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(selectedVehicles => {
          this.itemCount = selectedVehicles.length;
        });
    } else {
      this.store
        .select(SharedListToggleState.selectedVehicles)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(selectedVehicles => {
          this.itemCount = selectedVehicles.length;
        });
    }
  }
}
